/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCookingChallengeTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCookingChallenge,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Cooking!",
    "Cooking Challenge Awaits!",
    "Who Will Be the Chef?",
  ],
  title: "Cooking Challenge",
  description: "Organize an exciting cooking challenge.",
  longDescription:
    "Gather your friends for a fun cooking challenge! Choose a date, decide on ingredients, and plan dishes to prepare!",
  emoji: "👩",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Cooking Challenge",
          emoji: "👩",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the cooking challenge?",
          emoji: "📅",
          completeAction: {
            question: "Decide on ingredients to use?",
            description:
              "What ingredients should we focus on for our challenge?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What ingredients should we consider?",
                emoji: "🍅",
                completeAction: {
                  question: "Decide on dishes to prepare?",
                  description: "What dishes should we aim to create?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What dishes should we choose?",
                      emoji: "🍽",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Cook Up a Storm!",
    outroDescription:
      "Your cooking challenge plans are set! Enjoy the competition!",
  },
};
